<div class="toggle">
    <input type="radio" name="sizeBy" value="weight" id="sizeWeight" checked [(ngModel)]="checked" (click)="onCheck(0)" [disabled]="disabled"/>
    <label for="sizeWeight">עדכון מערכת שעות קבועה לכיתה/תלמיד</label>
    <input type="radio" name="sizeBy" value="dimensions" id="sizeDimensions" [(ngModel)]="checked" (click)="onCheck(1)" />
    <label for="sizeDimensions">עדכון מערכת שעות תקופתית/חופשה לכיתה/תלמיד</label>
</div>
<div></div>
